import type { GrButtonVariant } from '@components/button';

import type { GrModalConfig } from '../modal';

export type GrConfirmTone = 'info' | 'warning' | 'danger' | 'success' | 'brand';

export interface GrConfirmOptions {
  /** Dialog header. Sentence case, e.g. `'Delete report'`. */
  title: string;
  /** The question itself, e.g. `'Delete "Monthly NPS"?'`. */
  message?: string;
  /** What the action actually does — consequences, and anything it will *not* touch. */
  description?: string;
  /** Material icon name. Defaults from `iconTone`. */
  icon?: string;
  /** Defaults to `'danger'` for a danger confirm button, `'info'` otherwise. */
  iconTone?: GrConfirmTone;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: GrButtonVariant;
  confirmIcon?: string;
  /** Renders a single acknowledge button — the result is always `true`. */
  dismissOnly?: boolean;
  width?: string;
}

export interface GrConfirmModalData extends GrModalConfig {
  message?: string;
  description?: string;
  icon?: string;
  iconTone?: GrConfirmTone;
}

export const GR_CONFIRM_TONE_ICONS: Record<GrConfirmTone, string> = {
  info: 'info',
  warning: 'warning_amber',
  danger: 'warning',
  success: 'check_circle',
  brand: 'help_outline',
};

export const GR_CONFIRM_DEFAULT_WIDTH = '36vw';

export const GR_CONFIRM_BREAKPOINTS: Record<string, string> = {
  '1280px': '48vw',
  '960px': '70vw',
  '640px': '100vw',
};
